import AppSubMenu from "./AppSubMenu";
import {useFilteredMenu} from "../../hooks/useFilterMenu";
import {apiMenu} from "../../config/menu";


const AppMenu = () => {
    const menu = useFilteredMenu(apiMenu)
    return <AppSubMenu model={menu} />;
};

export default AppMenu;
